var map = {
	"./Bar Mojito.jpg": 266,
	"./Bar et sièges.jpg": 510,
	"./Carte.jpg": 168,
	"./Décoration de la Salle.jpg": 522,
	"./Horloge de la Salle.jpg": 144,
	"./Salle à manger de jour.jpg": 233,
	"./Salle à manger de nuit.jpg": 377,
	"./Terrasse.jpg": 58
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 769;